import React from 'react';

const BLOCKS = [
  {
    id: 'events',
    label: 'Eventos',
    sub: 'Servicios y actividades',
    emoji: '📅',
    photo: 'https://firebasestorage.googleapis.com/v0/b/bethesda-espanol.firebasestorage.app/o/IMG_1933.jpg?alt=media&token=1413b930-6e77-4751-a339-5acf5fd1d7cd',
    height: 180,
    position: 'center 40%',
  },
  {
    id: 'prayer-modal',
    label: 'Oración',
    sub: 'Envía tu petición',
    emoji: '🙏',
    photo: 'https://firebasestorage.googleapis.com/v0/b/bethesda-espanol.firebasestorage.app/o/IMG_2148.jpg?alt=media&token=ef63e4b5-d3d3-4197-92e0-798ed220e731',
    height: 180,
  },
  {
    id: 'giving',
    label: 'Dar',
    sub: 'Diezmos y ofrendas',
    emoji: '💰',
    photo: 'https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?w=800&q=80',
    height: 110,
  },
];

export default function Home({ navigate }) {
  return (
    <>
      {/* Sermon Block */}
      <button
        onClick={() => navigate('sermon-calendar')}
        style={{
          position: 'relative',
          height: 110,
          borderRadius: 16,
          overflow: 'hidden',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          width: '100%',
          marginBottom: 12,
          boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
          transition: 'transform 0.2s, box-shadow 0.2s',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.25)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.18)'; }}
      >
        <img
          src="https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800&q=80"
          alt="Sermones"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 60%' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.15) 60%, transparent 100%)' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '12px 14px', textAlign: 'left' }}>
          <p style={{ fontSize: '1rem', fontWeight: 800, color: 'white', lineHeight: 1.2, marginBottom: 2, textShadow: '0 1px 4px rgba(0,0,0,0.4)' }}>
            📖 Puntos clave del último sermón
          </p>
          <p style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.8)', fontWeight: 500 }}>
            Notas y referencias bíblicas
          </p>
        </div>
      </button>

      {/* Photo Blocks Grid */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        marginBottom: 16,
      }}>
        {BLOCKS.map((block) => (
          <button
            key={block.id}
            onClick={() => navigate(block.id)}
            style={{
              position: 'relative',
              height: block.height,
              borderRadius: 16,
              overflow: 'hidden',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.25)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.18)'; }}
          >
            {/* Background Photo */}
            <img
              src={block.photo}
              alt={block.label}
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              objectPosition: block.position || 'center center',
              }}
            />

            {/* Dark overlay */}
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.15) 60%, transparent 100%)',
            }} />

            {/* Text */}
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              padding: '12px 14px',
              textAlign: 'left',
            }}>
              <p style={{
                fontSize: '1rem',
                fontWeight: 800,
                color: 'white',
                lineHeight: 1.2,
                marginBottom: 2,
                textShadow: '0 1px 4px rgba(0,0,0,0.4)',
              }}>
                {block.emoji} {block.label}
              </p>
              <p style={{
                fontSize: '0.72rem',
                color: 'rgba(255,255,255,0.8)',
                fontWeight: 500,
              }}>
                {block.sub}
              </p>
            </div>
          </button>
        ))}
      </div>
      {/* Social Media Block */}
      <button
        onClick={() => navigate('media')}
        style={{
          position: 'relative',
          height: 110,
          borderRadius: 16,
          overflow: 'hidden',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          width: '100%',
          boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
          transition: 'transform 0.2s, box-shadow 0.2s',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.25)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.18)'; }}
      >
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, #c9a84c, #f0d98a)' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '12px 14px', textAlign: 'left' }}>
          <p style={{ fontSize: '1rem', fontWeight: 800, color: '#5a3e00', lineHeight: 1.2, marginBottom: 2 }}>
            📱 Búscanos en nuestras redes sociales
          </p>
          <p style={{ fontSize: '0.72rem', color: 'rgba(90,62,0,0.7)', fontWeight: 500 }}>
            Facebook · Instagram · YouTube
          </p>
        </div>
      </button>
    </>
  );
}
